export default __webpack_public_path__ + "static/captain-53ba09994357be87b837dc754a0f1e3e.jpg";